module.exports = __webpack_public_path__ + "static/img/collective3.8777eb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/pictures/collective3.jpg
// module id = F6vi
// module chunks = 0